import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

export const homeHeroBanner = () => {
    if($('.section-hero')[0]) {
        $('.page-home .hero-content').slick({
            autoplay: !0,
            autoplaySpeed: 4000,
            asNavFor: '.page-home .hero-image',
            appendArrows: $('.hero-arrows'),
            fade: !0,
            prevArrow: '<span class="slick-prev"><i class="fa-light fa-arrow-left"></i></span>',
            nextArrow: '<span class="slick-next"><i class="fa-light fa-arrow-right"></i></span>',
        })

        $('.page-home .hero-image').slick({
            autoplay: !0,
            autoplaySpeed: 4000,
            asNavFor: '.page-home .hero-content',
            arrows: !1,
            fade: !0,
            draggable: !1,
            swipe: !1,
            swipeToSlide: !1,
            touchMove: !1,
        })

        $('.page-home .hero-content .slick-slide').each(function() {
            const el = $(this)

            $('.page-home .hero-content .slick-arrow').click(() => {
                if(el.hasClass('slick-current')) {
                    nt = el.find('.hero-text').attr('attr-pos')
                    $('.page-home .hero-count span').text(nt)
                }
            })
        })

        $('.page-home .hero-content').on('afterChange', () => {
            $('.page-home .hero-count span').text($('.page-home .hero-content .slick-current .hero-text').attr('attr-pos'))
        })
    }
}

export const homeFeaturedArticles = () => {
    if($('.section-featured-articles')[0]) {
        $('.page-home .featured-image').slick({
            autoplaySpeed: 4000,
            asNavFor: '.page-home .featured-content',
            arrows: !1,
            fade: !0,
            draggable: !1,
            swipe: !1,
            swipeToSlide: !1,
            touchMove: !1,
        })

        $('.page-home .featured-content').slick({
            autoplaySpeed: 4000,
            asNavFor: '.page-home .featured-image',
            appendArrows: $('.featured-arrows'),
            fade: !0,
            prevArrow: '<span class="slick-prev"><i class="fa-light fa-arrow-left"></i></span>',
            nextArrow: '<span class="slick-next"><i class="fa-light fa-arrow-right"></i></span>',
        })
    }
}

export const homeReports = () => {
    const $el = $('.page-home .reports-row')

    if($el[0]) {
        $el.slick({
            slidesToShow: 2,
            centerMode: !0,
            centerPadding: 0,
            prevArrow: '<span class="slick-prev"><i class="fa-light fa-arrow-left"></i></span>',
            nextArrow: '<span class="slick-next"><i class="fa-light fa-arrow-right"></i></span>',
            appendArrows: $('.page-home .reports-arrows'),
            touchMove: !1,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                }
            }]
        })
    }
}

export const homeMostReadArticles = () => {
    const $el = $('.page-home .most-read-container')

    if($el[0]) {
        $el.on('init', (event, slick) => {
            $('.slick-current').prev().addClass('slick-left')
            $('.slick-current').next().addClass('slick-right')
        })

        $el.slick({
            slidesToShow: 3,
            centerMode: !0,
            centerPadding: 0,
            prevArrow: '<span class="slick-prev"><i class="fa-light fa-arrow-left"></i></span>',
            nextArrow: '<span class="slick-next"><i class="fa-light fa-arrow-right"></i></span>',
            touchMove: !1,
            rows: 0,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }]
        })

        const slickAnim = () => {
            $('.slick-slide').removeClass('slick-hide slick-left slick-right')
            $('.slick-current').prev().addClass('slick-left')
            $('.slick-current').prev().prev().addClass('slick-hide')
            $('.slick-current').next().addClass('slick-right')
            $('.slick-current').next().next().addClass('slick-hide')
            
            if($('.slick-last').hasClass('slick-current')) {
                $('.slick-last').prev().addClass('slick-left')
                $('.slick-last').next().addClass('slick-right')
                $('.slick-last').next().next().addClass('slick-hide')
            }
            
            if($('.slick-first').hasClass('slick-current')) {
                $('.slick-first').next().addClass('slick-right')
                $('.slick-first').prev().addClass('slick-left')
                $('.slick-first').prev().prev().addClass('slick-hide')
            }
        }
        $el.on('swipe', slickAnim)

        $el.find('.slick-arrow').click(() => {
            slickAnim()
        })
    }
}

export const sectionHeroBanner = () => {
    const $el = $('.section-banner .banner-image')
    
    if($el[0]) {
        $el.slick({
            autoplay: !0,
            arrows: !1,
            fade: !0,
            // draggable: !1,
            // swipe: !1,
            // swipeToSlide: !1,
            touchMove: !1,
        })
    }
}